<template>
	<div>
		<div v-if='listOfDeals.length === 0 && dealsChanged'>
			<div class='helperText' v-html='defaultText'>
			</div>
		</div>
		<ul  v-else class='deals__row c-deal-list' :class='type'>
			<template v-if='type=="list"'>
				<DealList v-for='deal in listOfDeals'
					:showDealValues='showDealValues'
					:showCreator='showCreator'
					:showCloneBtn='showCloneBtn'
					:showMakePrivateBtn='showMakePrivateBtn'
					:showDeleteBtn='showDeleteBtn'
					:showEditBtn='showEditBtn'
					:key='`deal-list-${deal.id}`'
					:deal='deal'
					@remove='remove' />
			</template>
			<template v-else-if='type=="card"'>
				<DealCard v-for='deal in listOfDeals'
					:key='`deal-card-${deal.id}`'
					:showDealValues='showDealValues'
					:showCreator='showCreator'
					:showCloneBtn='showCloneBtn'
					:showMakePrivateBtn='showMakePrivateBtn'
					:showDeleteBtn='showDeleteBtn'
					:showEditBtn='showEditBtn'
					:deal='deal'
					@remove='remove'
					@make-private='$emit("make-private", deal.id)'
					:page='page'
				/>
			</template>
			<template v-else-if='type=="table"' >
				<div class='grid'>
					<div class='grid-tr'>
						<div class='grid-td' v-for='(header, h) in headers' :key='`deal-table-header-${h}`'>
							<div class='c-table-item c-myPortfolio__table__header' v-html='header'></div>
						</div>
					</div>
					<DealTable v-for='deal in listOfDeals'
						:key='`deal-card-${deal.id}`'
						:showDealValues='showDealValues'
						:showCreator='showCreator'
						:showCloneBtn='showCloneBtn'
						:showMakePrivateBtn='showMakePrivateBtn'
						:showDeleteBtn='showDeleteBtn'
						:showEditBtn='showEditBtn'
						:deal='deal'
						@remove='remove' />
					<div class='grid-tr'>
						<div class='grid-td'>
							<div class='c-table-item c-myPortfolio__table__total'>Total</div>
						</div>
						<div class='grid-td' v-for='(sum, s) in calculateSum' :key='`deal-table-sum-${s}`'>
							<div class='c-table-item c-myPortfolio__table__total'>{{sum}}</div>
						</div>
					</div>
				</div>
			</template>
			<transition	name='fade' @before-enter='bodyScrollRemove' @after-leave='bodyScrollAdd'>
				<div class='popup popup--center' v-if='popup'>
					<section class='popup__main content__section'>
						<header class='popup__header'>
							<div class='headline headline--l1'>
								Are you sure you want to delete this deal?
							</div>
							<div class='popup__content'>
							</div>
							<footer class='popup__footer'>
								<link-item :params='{label: `Cancel`, class: "link--black"}' @LINK_CLICK='onClose' />
								<btn :params='{label: `Yes`, class: "waves-light"}' @click='removeItem' />
							</footer>
						</header>
					</section>
				</div>
			</transition>
		</ul>
	</div>

</template>

<script>
import btn from '__jsVueUI/btn.vue';
import linkItem from '__jsVueUI/link.vue';
import popup from '__jsLibs/popup';
import DealCard from './components/DealCard/DealCard.vue';
import DealList from './components/DealList/DealList.vue';
import DealTable from './components/DealTable/DealTable.vue';
export default {
	name: 'ListOfDeals',
	data() {
		return {
			url:     null,
			id:      null,
			popup:   false,
			headers: [
				'Deal name', 'Units', 'Rents', 'P.I.T.I', 'Operating<br>Expenses', 'Monthly<br>Cash Flow', 'DownPay<br>+Closing', 'Repairs<br>+Reno', 'C.O.C', 'Price'
			],
			dealsChanged: false
		};
	},
	props: {
		listOfDeals: {
			type: Array,
			default() {
				return [];
			}
		},
		type: {
			type:    String,
			default: 'card'
		},
		page: {
			type:    String,
			default: 'PastDeals'
		},
		showDealValues: {
			type:    Boolean,
			default: false
		},
		showCreator: {
			type:    Boolean,
			default: false
		},
		showCloneBtn: {
			type:    Boolean,
			default: true
		},
		showMakePrivateBtn: {
			type:    Boolean,
			default: false
		},
		showDeleteBtn: {},
		showEditBtn:   {},
		defaultText:   {
			type:    String,
			default: 'There are no deals'
		},
	},
	components: {
		btn,
		linkItem,
		DealCard,
		DealList,
		DealTable,
	},
	computed: {
		...mapGetters('main', ['header']),
		calculateSum: {
			get() {
				let sum = {
					units:              0,
					total_revenues:     0,
					piti:               0,
					operation_expenses: 0,
					cashflow:           0,
					downpay_closing:    0,
					repairs_renovation: 0,
					coc:                0,
					price:              0
				};
				this.listOfDeals.forEach((item) => {
					sum.units += (item.units) ? (item.units) : (0);
					sum.total_revenues += (item.total_revenues) ? (item.total_revenues) : (0);
					sum.piti += (item.piti) ? (item.piti) : (0);
					sum.operation_expenses += (item.operation_expenses) ? (item.operation_expenses) : (0);
					sum.cashflow += (item.cashflow) ? (item.cashflow) : (0);
					sum.downpay_closing += (item.downpay_closing) ? (item.downpay_closing) : (0);
					sum.repairs_renovation += (item.repairs_renovation) ? (item.repairs_renovation) : (0);
					// sum.coc += (item.coc) ? (item.coc) : (0);
					sum.price += (item.home_price) ? (Number.parseInt(item.home_price)) : (0);
				});

				sum.coc = ((sum.cashflow * 12) / (sum.downpay_closing + sum.repairs_renovation)) * 100;
				return Object.values({
					units:              `${(Math.floor(sum.units * 100) / 100).toString().replace(/\./g, ',')}`,
					total_revenues:     `$ ${(Math.floor(sum.total_revenues * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
					piti:               `$ ${(Math.floor(sum.piti * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
					operation_expenses: `$ ${(Math.floor(sum.operation_expenses * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
					cashflow:           `$ ${(Math.floor(sum.cashflow * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
					downpay_closing:    `$ ${(Math.floor(sum.downpay_closing * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
					repairs_renovation: `$ ${(Math.floor(sum.repairs_renovation * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
					coc:                `${(Math.floor(sum.coc * 100) / 100)}%`,
					price:              `$ ${(Math.floor(sum.price * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
				});
			}

		}
	},
	methods: {
		remove(data) {
			this.url = data.url;
			this.id = data.id;
			this.popup = true;
		},

		onClose() {
			this.popup = false;
		},

		async removeItem() {
			axios.defaults.headers.post[this.header.name] = this.header.value;
			axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
			await axios
				.post(this.url)
				.then(response => {
					if (this.$el.hasChildNodes()) {
						// this.$el.removeChild(this.$el.querySelector(`[data-item-id="${this.id}"]`));
						// this.onClose();
						// this.url = null;
						// this.id = null;

						// const items = document.querySelectorAll('[data-item-id]').length;
						// if (items === 0) {
						// 	window.location.href = '/deals/new';
						// }
						this.$emit('remove');
						this.onClose();
						this.url = null;
						this.id = null;
					}
				})
				.catch(err => {
					throw new Error(err);
				});
		},

		...popup
	},
	watch: {
		listOfDeals() {
			this.dealsChanged = true;
		},
	}
};
</script>
